import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import {Card, HiristBanner, BannerInfo} from '@jobseeker/lotus/components';
import {Paragraph} from '@jobseeker/lotus/elements';
import Link from '@mui/material/Link';
import {Table, TableBody, TableCell, TableHead, TableRow} from '@mui/material';
import {BannerTick} from '@jobseeker/lotus/assets/icons';

import HomePageFooter from '@components/HomeV2/homePageFooter';
import {useWrappedTheme} from '@jobseeker/lotus/hooks';
type PrivacyProps = {
  isMobile?: boolean;
};

const PrivacyPolicyPage = ({isMobile}: PrivacyProps) => {
  const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';
  const theme = useWrappedTheme();
  const DOMAIN = isAppIimjobs
    ? `${process.env.NEXT_PUBLIC_APP_NAME}.com`
    : `${process.env.NEXT_PUBLIC_APP_NAME}.tech`;
  const cookiesTable = [
    {
      category: 'Essential Cookies',
      description:
        'Essential cookies (First Party Cookies) are sometimes called "strictly necessary" as without them we cannot provide many services that you need on the Website. For example, essential cookies help remember your preferences as you move around the Website. Essential cookies also keep you logged in into a website. Without them the login functionality would not work.',
    },
    {
      category: 'Analytics Cookies',
      description:
        'These cookies track information about visits to the hirist.tech and partner (recruiter websites) websites so that we can make improvements and report our performance. For example: analyse visitor and user behavior so as to provide more relevant content or suggest certain activities. They collect information about how visitors use the Websites, which site the user came from, the number of each user’s visits and how long a user stays on the Websites. We might also use analytics cookies to test new ads, pages, or features to see how users react to them.',
    },
    {
      category: 'Functionality or Preference Cookies',
      description:
        'During your visit to the Websites, cookies are used to remember information you have entered or choices you make (such as your username, language or your region) on the Websites. They also store your preferences when personalizing the Websites to optimize your use of hirist.tech. These preferences are remembered, through the use of the persistent cookies, and the next time you visit the Websites you will not have to set them again.',
    },
    {
      category: 'Targeting or Advertising Cookies',
      description:
        'These Cookies are placed by third-party advertising platforms or networks or hirist.tech in order to deliver ads and track ad performance, enable advertising networks to deliver ads that may be relevant to you based upon your activities (this is sometimes called "behavioral" "tracking" or "targeted" advertising) on the Websites. They may subsequently use information about your visit to target you with advertising that you may be interested in, on hirist.tech websites or other websites. For example, these cookies remember which browsers have visited the websites.',
    },
  ];
  return (
    <Box>
      {!isAppIimjobs && (
        <HiristBanner>
          <BannerInfo
            Icon={BannerTick}
            isMobile={!!isMobile}
            subTitle={'Privacy Policy'}
            title={''}
          />
        </HiristBanner>
      )}
      <Box
        sx={{
          maxWidth: '1340px',
          // width: '1050px',
          // width: '100%',
          margin: '0 auto',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          mx: isAppIimjobs
            ? {lg: '195px'}
            : {xxs: '10px', md: '30px', lg: '50px'},
          my: isAppIimjobs ? '0px' : {xxs: '12px', sm: '12px', md: '40px'},
        }}
      >
        <Card
          variant=""
          heading=""
          sx={{
            px: !isAppIimjobs ? {xxs: '12px', xs: '12px', sm: '20px'} : '',
            py: !isAppIimjobs ? {xxs: '13px', xs: '13px', sm: '20px'} : '',
          }}
        >
          {isAppIimjobs && (
            <Typography
              sx={{
                fontFamily: 'Poppins',
                fontSize: '24px',
                fontWeight: 500,
                lineHeight: '30px',
                textAlign: 'Center',
                color: 'secondary.dark',
                marginBottom: '40px',
              }}
            >
              PRIVACY POLICY
            </Typography>
          )}

          <Paragraph
            title="1. Introduction"
            style={
              !isAppIimjobs && {
                fontSize: '16px',

                lineHeight: '27px',
                fontWeight: '400',
              }
            }
            titleStyle={
              !isAppIimjobs && {
                fontSize: '16px',
                fontWeight: 'fontWeightBold',
              }
            }
            body={
              <>
                We, at Info Edge (India) Limited and our affiliated
                companies/brands worldwide (hereinafter collectively referred to
                as &quot;IEIL&quot;), are committed to respecting your online
                privacy and recognize the need for appropriate protection and
                management of any personally identifiable information you share
                with us. This Privacy Policy (&quot;Policy&quot;) describes how
                IEIL collects, uses, discloses and transfers personal
                information of users through its websites and applications,
                including through{' '}
                {isAppIimjobs
                  ? 'iimjobs.com, hirist.tech'
                  : 'hirist.tech, iimjobs.com'}
                , mobile applications and online services (collectively, the
                &quot;Platform&quot;). This policy applies to those who visit
                the Platform, or whose information IEIL otherwise receives in
                connection with its services (such as contact information of
                individuals associated with IEIL including partners)
                (hereinafter collectively referred to as &quot;Users&quot;). For
                the purposes of the Privacy Policy, &quot;You&quot; or
                &quot;Your&quot; shall mean the person who is accessing the
                Platform.
              </>
            }
          />
          <Paragraph
            title="2. Types of Personal Information collected by IEIL (Info Edge (India) Limited)"
            style={
              !isAppIimjobs && {
                fontSize: '16px',

                lineHeight: '27px',
                fontWeight: '400',
              }
            }
            titleStyle={
              !isAppIimjobs && {
                fontSize: '16px',
                fontWeight: 'fontWeightBold',
              }
            }
            body={
              <>
                &quot;Personal information&quot; (PI) - means any information
                relating to an identified or identifiable natural person
                including common identifiers such as a name, an identification
                number, location data, an online identifier or one or more
                factors specific to the physical, physiological, genetic,
                mental, economic, cultural or social identity of that natural
                person and any other information that is so categorized by
                applicable laws. We collect information about you and/or your
                usage to provide better services and offerings. The Personal
                Information that we collect, and how we collect it, depends upon
                how you interact with us. We collect the following categories of
                Personal Information in the following ways:
                <Box
                  component="ul"
                  sx={{
                    // listStyleType: 'lower-roman',
                    ...(!isAppIimjobs && {
                      li: {
                        mt: 0,
                        '::marker': {
                          color: theme.palette.primary.main,
                        },
                      },
                      pl: 4.5,
                    }),
                  }}
                >
                  <li>
                    name, email address, password, country, city, contact number
                    and company/organization that you are associated with, when
                    the you sign up for alerts on the Platform;
                  </li>

                  <li>
                    information that one would usually include in a resume,
                    including name, contact details including email address and
                    mobile number, work experience, educational qualifications,
                    data relating to your current and past remuneration or
                    salary, a copy of your resume, etc. when you register on the
                    Platform;
                  </li>

                  <li>
                    information about the services that you use and how you use
                    them, including log information and location information,
                    when you are a user of the services through the Platform;
                  </li>

                  <li>
                    we may collect your Personal Information such as name, age,
                    contact details, preferences, etc. through surveys and
                    forms, when you choose to participate in these surveys etc.;
                  </li>

                  <li>
                    we may also collect information relating to your caste and
                    information about whether you are eligible for any
                    affirmative action&nbsp;programmes&nbsp;or policies, if you
                    opt to provide such information;
                  </li>

                  <li>
                    when you communicate with IEIL or use the Platform to
                    communicate with other Users (such as partners), we collect
                    information about your communication and any information you
                    choose to provide;
                  </li>

                  <li>
                    when you visit the Platform, we use cookies to automatically
                    collect, store and use technical information about your
                    system and interaction with our Platform;
                  </li>

                  <li>
                    when you use a device to access the Platform, IEIL may
                    collect technical or other related information from the
                    device as well as the device location;
                  </li>

                  <li>
                    To the extent permitted by law, IEIL may record and monitor
                    your communications with us to ensure compliance with our
                    legal and regulatory obligations and our internal policies;
                  </li>

                  <li>
                    If you choose to sign in with your social media account to
                    access the Platform, or otherwise connect your social media
                    account with the services of the Platform, you consent to
                    our collection, storage, and use, in accordance with this
                    Privacy Policy, of the information that you make available
                    to us through the social media interface. Please see your
                    social media provider&apos;s privacy policy and
                    help&nbsp;centre&nbsp;for more information about how they
                    share information when you choose to connect your account.
                  </li>
                </Box>
              </>
            }
          />
          <Paragraph
            title="3. How IEIL (Info Edge (India) Limited) may use your Personal Information"
            style={
              !isAppIimjobs && {
                fontSize: '16px',

                lineHeight: '27px',
                fontWeight: '400',
              }
            }
            titleStyle={
              !isAppIimjobs && {
                fontSize: '16px',
                fontWeight: 'fontWeightBold',
              }
            }
            body={
              <>
                We will only use your personal data in a fair and reasonable
                manner, and where we have a lawful reason to do so.
                <br />
                Our use of your personal data depends on the purpose for which
                you interact with us. We may process your Personal Information
                for the following purposes:
                <Box
                  component="ul"
                  sx={{
                    // listStyleType: 'lower-roman',
                    ...(!isAppIimjobs && {
                      li: {
                        mt: 0,
                        '::marker': {
                          color: theme.palette.primary.main,
                        },
                      },
                      pl: 4.5,
                    }),
                  }}
                >
                  <li>
                    Providing our services and products to you including to send
                    you job alerts, calendar alerts, relevant search results,
                    recommended jobs and/or candidates (as the case maybe), and
                    other social media communication facilities.
                  </li>

                  <li>
                    Protecting our Users and providing you with customer
                    support.
                  </li>

                  <li>
                    We use information collected from cookies and other
                    technologies, to improve your user experience and the
                    overall quality of our services (for more information please
                    refer to paragraph 4 below). When showing you tailored ads,
                    we will not associate an identifier from cookies or similar
                    technologies with sensitive categories, such as those based
                    on race, religion, sexual orientation or health.
                  </li>

                  <li>
                    Improving the Platform and its content to provide better
                    features and services.
                  </li>

                  <li>
                    Conducting market research and surveys with the aim of
                    improving our products and services.
                  </li>

                  <li>
                    Sending you information about our products and services for
                    marketing purposes and promotions.
                  </li>

                  <li>
                    <span>
                      Preventing, detecting, investigating and taking action
                      against crimes (including but not limited to fraud and
                      other financial crimes), any other illegal activities,
                      suspected fraud, or violations of IEIL&apos;s Terms of Use
                      in any jurisdiction
                    </span>
                  </li>

                  <li>
                    <span>
                      To the extent required for identity verification,
                      government sanctions screening and due diligence checks.
                    </span>
                  </li>

                  <li>
                    <span>
                      Establishing, exercising or defending legal rights in
                      connection with legal proceedings (including any
                      prospective legal proceedings) and seeking professional or
                      legal advice in relation to such legal proceedings.
                    </span>
                  </li>
                </Box>
              </>
            }
          />

          <Paragraph
            title="4. Cookies and Other Tracking Technologies"
            style={
              !isAppIimjobs && {
                fontSize: '16px',

                lineHeight: '27px',
                fontWeight: '400',
              }
            }
            titleStyle={
              !isAppIimjobs && {
                fontSize: '16px',
                fontWeight: 'fontWeightBold',
              }
            }
            body={
              <>
                Some of our web pages utilize &quot;cookies&quot; and other
                tracking technologies. A &quot;cookie&quot; is a small text file
                that may be used, for example, to collect information about
                web-site activity. Some cookies and other technologies may serve
                to recall Personal Information previously indicated by a user.
                Most browsers allow you to control cookies, including whether or
                not to accept them and how to remove them.
                <br />
                You may set most browsers to notify you if you receive a cookie,
                or you may choose to block cookies with your browser, but please
                note that if you choose to erase or block your cookies, you will
                need to re-enter your original user ID and password to gain
                access to certain parts of the Platform.
                <br />
                Tracking technologies may record information such as Internet
                domain and host names; Internet protocol (IP) addresses; browser
                software and operating system types; clickstream patterns; and
                dates and times that our site is accessed. Our use of cookies
                and other tracking technologies allows us to improve our
                Platform and the overall website experience. We may also analyse
                information that does not contain Personal Information for
                trends and statistics.
                <br />
                For more information about our use of cookies please refer to
                our{' '}
                <Link href="/cookiepolicy" target="_blank">
                  <Typography
                    component={'span'}
                    sx={{
                      color: isAppIimjobs
                        ? 'primary.main'
                        : 'rgba(0, 0, 0, .5)',
                      fontSize: '16px',
                    }}
                  >
                    Cookie Policy.
                  </Typography>
                </Link>
              </>
            }
          />
          <Paragraph
            title="5. The Basis/ Grounds which we rely on for collection and processing
          of your Personal Information:"
            style={
              !isAppIimjobs && {
                fontSize: '16px',

                lineHeight: '27px',
                fontWeight: '400',
              }
            }
            titleStyle={
              !isAppIimjobs && {
                fontSize: '16px',
                fontWeight: 'fontWeightBold',
              }
            }
            body={
              <>
                Your Personal Information is collected and processed by IEIL
                based on the following legal grounds depending upon the nature
                of Personal Information and the purposes for which it is
                processed.
                <Box
                  component="ul"
                  sx={{
                    // listStyleType: 'lower-roman',
                    ...(!isAppIimjobs && {
                      li: {
                        mt: 0,
                        '::marker': {
                          color: theme.palette.primary.main,
                        },
                      },
                      pl: 4.5,
                    }),
                  }}
                >
                  <li>
                    Consent:
                    <Paragraph
                      title=""
                      style={{
                        ...(!isAppIimjobs && {
                          fontSize: '16px',

                          lineHeight: '27px',
                          fontWeight: '400',
                        }),
                      }}
                      body={
                        <>
                          IEIL relies on your consent in order to process your
                          Personal Information in certain situations. If IEIL
                          requires your consent to collect and process certain
                          Personal Information, as per the requirements under
                          the applicable data protection laws, your consent is
                          sought at the time of collection of your Personal
                          Information and such processing will only be performed
                          where consent is secured.
                        </>
                      }
                    />
                  </li>
                  <li>
                    Compliance with a legal obligation:
                    <Paragraph
                      title=""
                      style={{
                        ...(!isAppIimjobs && {
                          fontSize: '16px',

                          lineHeight: '27px',
                          fontWeight: '400',
                        }),
                      }}
                      body={
                        <>
                          Your Personal Information may be processed by IEIL, to
                          the extent that such processing is necessary to allow
                          IEIL to comply with a legal obligation. An example of
                          this would be if IEIL is required to disclose your
                          Personal Information to respond to a court order or if
                          IEIL is required to retain specific records for a
                          fixed period to comply with requirements under any
                          applicable law.
                        </>
                      }
                    />
                  </li>
                </Box>
              </>
            }
          />
          <Paragraph
            title="6. Information Sharing and Disclosure"
            style={
              !isAppIimjobs && {
                fontSize: '16px',

                lineHeight: '27px',
                fontWeight: '400',
              }
            }
            titleStyle={
              !isAppIimjobs && {
                fontSize: '16px',
                fontWeight: 'fontWeightBold',
              }
            }
            body={
              <>
                We restrict access to your Personal Information to employees who
                we believe reasonably need to know/or that information to fulfil
                their jobs to provide, operate, develop, or improve our products
                or services.
                <br />
                IEIL does not disclose, transfer or share your Personal
                Information with others except with:
                <Box
                  component="ul"
                  sx={{
                    // listStyleType: 'lower-roman',
                    ...(!isAppIimjobs && {
                      li: {
                        mt: 0,
                        '::marker': {
                          color: theme.palette.primary.main,
                        },
                      },
                      pl: 4.5,
                    }),
                  }}
                >
                  <li>
                    Our affiliates and group companies to the extent required
                    for our internal business and/or administrative purposes
                    and/or general corporate operations and for provision of
                    services;
                  </li>
                  <li>
                    Potential recruiters if we determine that your resume
                    matches a particular job description/ vacancy available with
                    such recruiters. By registering on the Platform and
                    consenting to the terms of this Privacy Policy, you agree
                    that IEIL may contact you or forward your resume to
                    potential recruiters;
                  </li>
                  <li>
                    Third parties including enforcement, regulatory and judicial
                    authorities, if we determine that disclosure of your
                    Personal Information is required to a) respond to subpoenas,
                    court orders, or legal process, or to establish or exercise
                    our legal rights or defend against legal claims; or b)
                    investigate, prevent, or take action regarding illegal
                    activities, suspected fraud, situations involving potential
                    threats to the physical safety of any person, violations of
                    IEIL&apos;s Terms of Use or as otherwise required by law;
                  </li>
                  <li>
                    In the event of a merger, acquisition, financing, or sale of
                    assets or any other situation involving the transfer of some
                    or all of IEIL&apos;s business assets we may disclose
                    Personal Information to those involved in the negotiation or
                    transfer.
                  </li>
                  <li>
                    Third party service providers and marketing partners that
                    IEIL engages to a) provide services over the Platform on
                    IEIL&apos;s behalf; b) maintain the Platform and mailing
                    lists; or c) communicate with you on IEIL&apos;s behalf
                    about offers relating to its products and/or services. IEIL
                    will take reasonable steps to ensure that these third-party
                    service providers are obligated to protect your Personal
                    Information and are also subject to appropriate
                    confidentiality / non-disclosure obligations.
                  </li>
                  <li>
                    Third party advertisers to display advertisements to you
                    when you visit the Platform. The third-party advertisers
                    include financial service providers (such as banks,
                    insurance agents, stock brokers and mortgage lenders) and
                    non-financial companies (such as stores, airlines, and
                    software companies). These companies may use information
                    about you and your visits to this Platform and other web
                    sites to provide advertisements on this Platform.
                  </li>
                </Box>
                The Company does not provide any Personal Information to the
                advertiser when you interact with or view a targeted
                advertisement. However, if you interact with or view an
                advertisement, the advertiser may make certain assumptions and,
                in the process, learn certain Personal Information about you.
                For instance, if you view and click an advertisement that is
                targeted towards women in the age group 18- 24 from a specific
                geographic area, the advertiser may assume that you meet the
                relevant criteria.
                <br />
                IEIL does not intend to transfer Personal Information without
                your consent to third parties who are not bound to act on
                IEIL&apos;s behalf unless such transfer is legally required.
                <br />
                If your Personal Information is transferred outside India, we
                take the necessary steps to protect your Personal Information in
                accordance with applicable data protection laws.
              </>
            }
          />
          <Paragraph
            title="7. Third Party Content:"
            style={
              !isAppIimjobs && {
                fontSize: '16px',

                lineHeight: '27px',
                fontWeight: '400',
              }
            }
            titleStyle={
              !isAppIimjobs && {
                fontSize: '16px',
                fontWeight: 'fontWeightBold',
              }
            }
            body={
              <>
                Please be aware that the Platform sometimes contains links to
                other sites that are not governed by this Privacy Policy. Users
                may be directed to third-party sites for more information, such
                as advertisers, blogs, content sponsorships, vendor services,
                social networks, etc.
                <Paragraph
                  title=""
                  style={{
                    ...(!isAppIimjobs && {
                      fontSize: '16px',

                      lineHeight: '27px',
                      fontWeight: '400',
                    }),
                  }}
                  body={
                    <>
                      IEIL makes no representations or warranties regarding how
                      your information is stored or used on third-party servers.
                      We recommend that you review the applicable privacy
                      statements and policies of each third-party site linked
                      from the Platform to determine their use of your personal
                      information.
                    </>
                  }
                />
              </>
            }
          />

          <Paragraph
            title="8. Children"
            style={
              !isAppIimjobs && {
                fontSize: '16px',

                lineHeight: '27px',
                fontWeight: '400',
              }
            }
            titleStyle={
              !isAppIimjobs && {
                fontSize: '16px',
                fontWeight: 'fontWeightBold',
              }
            }
            body={
              <>
                To use the Platform, you agree that you must be the minimum age
                (described in this paragraph below) or older.
                <br />
                The minimum age for these purposes shall be eighteen (18),
                however if local laws require that you must be older for IEIL to
                be able to lawfully provide the services over the Platform to
                you then that older age shall apply as the applicable minimum
                age.
                <br />
                If you are under the age of 18 or the age of majority in your
                jurisdiction, you must use the Platform under the supervision of
                your parent, legal guardian or responsible adult.
              </>
            }
          />

          <Paragraph
            title="9. Retention of Personal Information"
            style={
              !isAppIimjobs && {
                fontSize: '16px',

                lineHeight: '27px',
                fontWeight: '400',
              }
            }
            titleStyle={
              !isAppIimjobs && {
                fontSize: '16px',
                fontWeight: 'fontWeightBold',
              }
            }
            body={
              <>
                Your Personal Information will not be retained by IEIL any
                longer than it is necessary for the purposes for which the
                Personal Information is processed and/or in accordance with
                legal, regulatory, contractual or statutory obligations as
                applicable.
                <br />
                At the expiry of such periods, your Personal Information will be
                deleted or archived in compliance with applicable laws
              </>
            }
          />

          <Paragraph
            title="10. Controlling your personal information"
            style={
              !isAppIimjobs && {
                fontSize: '16px',

                lineHeight: '27px',
                fontWeight: '400',
              }
            }
            titleStyle={
              !isAppIimjobs && {
                fontSize: '16px',
                fontWeight: 'fontWeightBold',
              }
            }
            body={
              <>
                You have the right to invoke your rights which are available to
                data principals or data subjects (as per applicable laws and
                regulations) in relation to your Personal Information which is
                being processed by IEIL.
                <br />
                IEIL provides you the ability to keep your Personal Information
                accurate and up-to-date. If at any time you would like to a)
                rectify, update or correct your Personal Information; b) obtain
                confirmation on whether or not your Personal Information is
                processed by it; c) access your Personal Information or exercise
                your right to data portability; or d) exercise your right to
                restrict the continuing disclosure of your Personal Information
                to any third party by IEIL in certain circumstances, you are
                requested to contact us using the contact details mentions in
                paragraph 15 below. We will require you to provide a valid proof
                of your identity, in order to ensure that your rights are
                respected.
                <br />
                For the exercise of certain rights, you may be required to
                approach the relevant authority / designated officer as per the
                provisions of the applicable data protection laws/ IEIL may in
                accordance with the provisions of applicable data protection
                laws, charge a fee for fulfilling your request, in particular in
                case of excessive or manifestly unfounded request. Further you
                acknowledge that the above-mentioned rights are not absolute and
                are subject to limitations as per the applicable data protection
                laws.
                <br />
                At any time, if you wish to delete your account on {DOMAIN}, you
                may do so by writing an email to privacy@{DOMAIN}.
              </>
            }
          />

          <Paragraph
            title="11. Confidentiality and Security"
            style={
              !isAppIimjobs && {
                fontSize: '16px',

                lineHeight: '27px',
                fontWeight: '400',
              }
            }
            titleStyle={
              !isAppIimjobs && {
                fontSize: '16px',
                fontWeight: 'fontWeightBold',
              }
            }
            body={
              <>
                <Box
                  component="ul"
                  sx={{
                    // listStyleType: 'lower-roman',
                    ...(!isAppIimjobs && {
                      li: {
                        mt: 0,
                        '::marker': {
                          color: theme.palette.primary.main,
                        },
                      },
                      pl: 1.5,
                    }),
                  }}
                >
                  <li>
                    The security and confidentiality of your Personal
                    Information is important to us and IEIL has invested
                    significant resources to protect the safekeeping and
                    confidentiality of your personal data. When using external
                    service providers acting as processors, we require that they
                    adhere to the same standards as IEIL does. Regardless of
                    where your Personal Information is transferred or stored, we
                    take all steps reasonably necessary to ensure that personal
                    data is kept secure.
                  </li>
                  <li>
                    We seek to ensure compliance with the requirements of the
                    Information Technology Act, 2000 and Rules made there under
                    to ensure the protection and preservation of your privacy.
                    By accepting the terms of this Privacy Policy, you agree
                    that the standards and practices being implemented by us,
                    are reasonable and sufficient for the protection of your
                    Personal Information.
                  </li>
                </Box>
              </>
            }
          />

          <Paragraph
            title="12. Social media"
            style={
              !isAppIimjobs && {
                fontSize: '16px',

                lineHeight: '27px',
                fontWeight: '400',
              }
            }
            titleStyle={
              !isAppIimjobs && {
                fontSize: '16px',
                fontWeight: 'fontWeightBold',
              }
            }
            body={
              <>
                IEIL operates channels, pages and accounts on some social media
                sites to inform, assist and engage with customers. IEIL monitors
                and records comments and posts made on these channels about
                itself in order to improve its products and services.
                <br />
                Please note that you must not communicate the following
                information to IEIL through such social media sites:
                <br />
                sensitive personal data including (i) special categories of
                personal data meaning any information revealing racial or ethnic
                origin, political opinions, religious or philosophical beliefs,
                or trade union membership, and the processing of genetic data,
                biometric data for the purpose of uniquely identifying a natural
                person, data concerning health or data concerning a natural
                person&apos;s sex life or sexual orientation and (ii) other
                sensitive personal data such as criminal convictions and
                offences and national identification number ; - Excessive,
                inappropriate, offensive or defamatory content. IEIL is not
                responsible for any information posted on those sites other than
                the information posted by its employees on its behalf. IEIL is
                only responsible for its own use of the Personal Information
                received through such sites.
              </>
            }
          />

          <Paragraph
            title="13. Changes to this Privacy Policy"
            style={
              !isAppIimjobs && {
                fontSize: '16px',

                lineHeight: '27px',
                fontWeight: '400',
              }
            }
            titleStyle={
              !isAppIimjobs && {
                fontSize: '16px',
                fontWeight: 'fontWeightBold',
              }
            }
            body={
              <>
                IEIL reserves the right to update, change or modify this Privacy
                Policy at any time. The Privacy Policy shall come to effect from
                the date of publication of such update, change or modification.
              </>
            }
          />

          <Paragraph
            title="14. Disclaimer"
            style={
              !isAppIimjobs && {
                fontSize: '16px',

                lineHeight: '27px',
                fontWeight: '400',
              }
            }
            titleStyle={
              !isAppIimjobs && {
                fontSize: '16px',
                fontWeight: 'fontWeightBold',
              }
            }
            body={
              <>
                IEIL does not store any account related information or any
                credit/debit card details. IEIL shall not be liable for any loss
                or damage sustained by Users as a result of any disclosure
                (inadvertent or otherwise) of any information concerning the
                User&apos;s account, credit cards or debit cards in the course
                of any online transactions or payments made for any products
                and/or services offered through the Platform.
                <br />
                In case any Personal Information is shared by you with IEIL,
                which is not requested by IEIL during registration, (whether
                mandatory or optional), IEIL will not be liable for any
                information security breach or disclosure in relation to such
                information.
                <br />
                If you have any questions regarding this Privacy Policy or the
                protection of your Personal Information, please contact
                IEIL&apos;s Data Protection Officer/ Grievance Officer at the
                following:
              </>
            }
          />

          <Paragraph
            title="15. Data Protection Officer/ Grievance Officer"
            style={
              !isAppIimjobs && {
                fontSize: '16px',

                lineHeight: '27px',
                fontWeight: '400',
              }
            }
            titleStyle={
              !isAppIimjobs && {
                fontSize: '16px',
                fontWeight: 'fontWeightBold',
              }
            }
            body={
              <>
                In case you have any complaints and/or grievances in relation to
                the processing of your Personal Information you can send your
                complaints via e-mail to our grievance officer:
                <br />
                Grievance Officer
                <br />
                Info Edge (India) Limited
                <br />
                Email: privacy@{DOMAIN}
              </>
            }
          />
          {/** 'Cookie Policy'to be done */}

          {!isAppIimjobs ? (
            <>
              <Typography sx={{fontSize: '16px', fontWeight: 'fontWeightBold'}}>
                Cookie Policy
              </Typography>
              <br></br>
              <Paragraph
                title="Introduction"
                style={
                  !isAppIimjobs && {
                    fontSize: '16px',

                    lineHeight: '27px',
                    fontWeight: '400',
                  }
                }
                titleStyle={
                  !isAppIimjobs && {
                    fontSize: '16px',
                    fontWeight: 'fontWeightBold',
                  }
                }
                body={
                  <>
                    This Cookie Policy (&quot;Policy&quot;) explains that we
                    believe in being open and clear about how we use your
                    information. In the spirit of transparency, this Policy
                    provides detailed information about how and when we use
                    cookies on our websites. This cookie policy applies to any
                    hirist.tech product or service that links to this policy or
                    incorporates it by reference.
                  </>
                }
              />
              <Paragraph
                title="a. Does hirist.tech use cookies?"
                style={
                  !isAppIimjobs && {
                    fontSize: '16px',

                    lineHeight: '27px',
                    fontWeight: '400',
                  }
                }
                titleStyle={
                  !isAppIimjobs && {
                    fontSize: '16px',
                    fontWeight: 'fontWeightBold',
                  }
                }
                body={
                  <>
                    hirist.tech uses cookies, tags and other technologies when
                    you use any of the hirist.tech websites, mobile sites or
                    mobile apps (collectively &quot;the services&quot;). Cookies
                    are used to ensure everyone has their best possible
                    experience. Cookies also help us keep your account safe. By
                    continuing to visit or use our services, you are agreeing to
                    the use of cookies and similar technologies for the purposes
                    we describe in this policy. If you prefer not to receive
                    cookies or web beacons, then you should stop using our site,
                    or consult your browsing and third-party cookie settings as
                    described below.
                  </>
                }
              />
              <Paragraph
                title="b. What is a cookie?"
                style={
                  !isAppIimjobs && {
                    fontSize: '16px',

                    lineHeight: '27px',
                    fontWeight: '400',
                  }
                }
                titleStyle={
                  !isAppIimjobs && {
                    fontSize: '16px',
                    fontWeight: 'fontWeightBold',
                  }
                }
                body={
                  <>
                    Cookies are small pieces of text stored by a website you
                    visit in your browser and subsequently sent by your web
                    browser in every request to the website. A cookie file is
                    stored in your web browser and allows the Site or a
                    third-party to recognize you and make your next visit easier
                    and the Site more useful to you. Essentially, cookies are a
                    user’s identification card for the hirist.tech servers.
                    Cookies allow hirist.tech to serve you better and more
                    efficiently, and to personalize your experience on our site.
                    Web beacons, tags and scripts may be used in the Websites or
                    in emails to help us to deliver cookies, count visits,
                    understand usage and campaign effectiveness and determine
                    whether an email has been opened and acted upon. We may
                    analyse or perform analysis based on the use of these
                    technologies and generate reports on an individual and
                    aggregated basis., Cookies can be &quot;persistent&quot; or
                    &quot;session&quot; cookies. A persistent cookie helps us
                    recognize you as an existing user, so it’s easier to return
                    to hirist.tech or interact with our services without signing
                    in again. After you sign in, a persistent cookie stays in
                    your browser and will be read by hirist.tech when you return
                    to one of our sites or a partner site that uses our
                    services. Session cookies only last for as long as the
                    session (usually the current visit to a website or a browser
                    session).
                  </>
                }
              />
              <Paragraph
                title="c. What are cookies used for?"
                style={
                  !isAppIimjobs && {
                    fontSize: '16px',

                    lineHeight: '27px',
                    fontWeight: '400',
                  }
                }
                titleStyle={
                  !isAppIimjobs && {
                    fontSize: '16px',
                    fontWeight: 'fontWeightBold',
                  }
                }
                body={
                  <>
                    When you visit our websites, we may place a number of
                    cookies in your browser. These are known as First Party
                    Cookies and are required to hold session information as you
                    navigate from page to page within the website. For example,
                    we use cookies on our websites to understand visitor and
                    user preferences, improve their experience, and track and
                    analyse usage, navigational and other statistical
                    information. Additionally, cookies allow us to bring you
                    advertising both on and off the hirist.tech site, and bring
                    customized features to you. You can control the use of
                    cookies at the individual browser level. If you elect not to
                    activate the cookie or to later disable cookies, you may
                    still visit our websites, but your ability to use some
                    features or areas of the Websites may be limited. We may use
                    any of the following categories of cookies on the Websites
                    as detailed below. Each cookie falls within one of the four
                    following categories:
                    <Table sx={{border: '1px solid rgba(0, 0, 0, 0.2)'}}>
                      <TableHead>
                        <TableRow
                          sx={{borderBottom: '1px solid rgba(0, 0, 0, 0.2)'}}
                        >
                          <TableCell
                            align="center"
                            sx={{
                              borderRight: '1px solid rgba(0, 0, 0, 0.2)',
                              textAlign: 'center',
                            }}
                          >
                            <Paragraph
                              title="Category"
                              body=""
                              titleStyle={{
                                color: 'rgba(0, 0, 0, .7)',
                                fontWeight: 'bold',
                              }}
                            />
                          </TableCell>
                          <TableCell align="center">
                            <Paragraph
                              title="Description"
                              body=""
                              titleStyle={{
                                color: 'rgba(0, 0, 0, .7)',
                                fontWeight: 'bold',
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {cookiesTable.map((cookie, index) => (
                          <TableRow
                            key={index}
                            sx={{borderBottom: '1px solid rgba(0, 0, 0, 0.2)'}}
                          >
                            <TableCell
                              align="left"
                              sx={{
                                borderRight: '1px solid rgba(0, 0, 0, 0.2)',
                                textAlign: 'left',
                              }}
                            >
                              <Paragraph
                                title=""
                                body={cookie.category}
                                style={{}}
                              />
                            </TableCell>
                            <TableCell align="left">
                              <Paragraph
                                title=""
                                body={cookie.description}
                                style={{}}
                              />
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </>
                }
              />
              {/**Pending work */}
              <Paragraph
                title="d. When does hirist.tech place cookies?"
                style={
                  !isAppIimjobs && {
                    fontSize: '16px',

                    lineHeight: '27px',
                    fontWeight: '400',
                  }
                }
                titleStyle={
                  !isAppIimjobs && {
                    fontSize: '16px',
                    fontWeight: 'fontWeightBold',
                  }
                }
                body={
                  <>
                    We use cookies on our websites, mobile sites and mobile
                    applications. Any browser visiting these sites will receive
                    cookies from us which helps us identify you more quickly
                    when you return. Cookies help us to determine which pages or
                    information you find most useful or interesting on our own
                    websites.
                    {!isAppIimjobs && <br></br>}
                    {!isAppIimjobs && <br></br>}
                    hirist.tech may also have some cookies for its own analytics
                    i.e., analytics not part of Google Analytics. Such cookies
                    help generate statistics and reports about visitors and
                    their activities on the website or app.
                  </>
                }
              />
              <Paragraph
                title="e. How are cookies used for online analytics purposes?"
                style={
                  !isAppIimjobs && {
                    fontSize: '16px',

                    lineHeight: '27px',
                    fontWeight: '400',
                  }
                }
                titleStyle={
                  !isAppIimjobs && {
                    fontSize: '16px',
                    fontWeight: 'fontWeightBold',
                  }
                }
                body={
                  <>
                    We may use web analytics services on hirist.tech, such as
                    those of Google Analytics. These services help us analyse
                    how users use the services, including by noting the
                    third-party website from which you arrive. The information
                    collected by the technology will be disclosed to or
                    collected directly by such service providers, who use the
                    information to evaluate your use of the services. We also
                    use Google Analytics for certain purposes related to online
                    marketing, as described in the following sections.
                  </>
                }
              />
              <Paragraph
                title="f. How are cookies used for advertising purposes?"
                style={
                  !isAppIimjobs && {
                    fontSize: '16px',

                    lineHeight: '27px',
                    fontWeight: '400',
                  }
                }
                titleStyle={
                  !isAppIimjobs && {
                    fontSize: '16px',
                    fontWeight: 'fontWeightBold',
                  }
                }
                body={
                  <>
                    Cookies and other ad technology such as beacons, pixels, and
                    tags help us serve relevant ads to you more effectively.
                    They also help us provide aggregated auditing, research, and
                    reporting for advertisers, understand and improve our
                    service, and know when content has been shown to you. We
                    work with website analytics and advertising partners,
                    including Google Display Network, Facebook, etc. to deliver
                    hirist.tech advertisements on third party publisher websites
                    - these partners may set cookies on your computer&apos;s web
                    browser. These cookies allow our partners to recognize your
                    computer so that the ad server can show you hirist.tech
                    advertisements elsewhere on the Internet, and so that our
                    analytics software can measure your engagement and
                    interactions while using hirist.tech services. In this way,
                    ad servers may compile anonymous, de-identified information
                    about where you, or others who are using your computer, saw
                    our advertisements, whether or not you interacted with our
                    advertisements, and actions performed on subsequent visits
                    to hirist.tech websites and applications. This information
                    allows an ad network to deliver targeted advertisements that
                    they believe will be of most interest to you, and it allows
                    hirist.tech to optimize the performance of our advertising
                    campaigns and the usability of our website. In other words,
                    we use analytics data in concert with data about our online
                    ads that have been shown using the Google Display Network,
                    Facebook for Advertisers, or other online advertising
                    networks. By doing so, we can understand how anonymous users
                    interacted with our website after seeing our ads.
                  </>
                }
              />
              <Paragraph
                title="g. What third-party cookies does hirist.tech use?"
                style={
                  !isAppIimjobs && {
                    fontSize: '16px',

                    lineHeight: '27px',
                    fontWeight: '400',
                  }
                }
                titleStyle={
                  !isAppIimjobs && {
                    fontSize: '16px',
                    fontWeight: 'fontWeightBold',
                  }
                }
                body={
                  <>
                    Please note that the third parties (advertising networks and
                    providers of external services like web traffic analysis
                    services) may also use cookies on our Services. Cookies on
                    our sites. Also, note that the names of cookies, pixels and
                    other technologies may change over time.
                    {!isAppIimjobs && <br></br>}
                    {!isAppIimjobs && <br></br>}
                    We use trusted partners to help us service advertising, who
                    may place cookies on your device. We also pull through
                    content from social networks into our own pages, such as
                    embedded Facebook feeds. The social networks, such as
                    Facebook, Google, etc. may themselves also put cookies on
                    your machine. If a user logs into Facebook, Twitter or
                    Google+ via our website, they will leave a cookie on the
                    user&apos;s computer. This is the same process as if the
                    user logs into these social networks directly.
                    {!isAppIimjobs && <br></br>}
                    {!isAppIimjobs && <br></br>}
                    We also use Google Analytics on our Services to help us
                    analyse how our Services are used. Google Analytics uses
                    performance cookies to track customer’s interactions. For
                    example, by using cookies, Google can tell us which pages
                    our users view, which are most popular, what time of day our
                    websites are visited, whether visitors have been to our
                    websites before, what website referred the visitor to our
                    websites, and other similar information. All of this
                    information is anonymized.
                    {!isAppIimjobs && <br></br>}
                    {!isAppIimjobs && <br></br>}
                    We suggest that you should check the respective privacy
                    policies for these external services to help you understand
                    what data these organizations hold about you and how they
                    process it.
                    {!isAppIimjobs && <br></br>}
                    {!isAppIimjobs && <br></br>}
                    Facebook:{' '}
                    <a
                      href="https://www.facebook.com/policy.php"
                      target="_blank"
                      style={{color: 'black'}}
                    >
                      https://www.facebook.com/policy.php
                    </a>
                    {!isAppIimjobs && <br></br>}
                    {!isAppIimjobs && <br></br>}
                    AdSense:{' '}
                    <a
                      href="https://policies.google.com/technologies/ads"
                      target="_blank"
                      style={{color: 'black'}}
                    >
                      https://policies.google.com/technologies/ads
                    </a>
                    {!isAppIimjobs && <br></br>}
                    {!isAppIimjobs && <br></br>}
                    Google Analytics:{' '}
                    <a
                      href="https://www.google.com/analytics/learn/privacy.html"
                      target="_blank"
                      style={{color: 'black'}}
                    >
                      https://www.google.com/analytics/learn/privacy.html
                    </a>
                    {!isAppIimjobs && <br></br>}
                    {!isAppIimjobs && <br></br>}
                    Google Tag Manager:{' '}
                    <a
                      href="https://www.google.com/analytics/tag-manager/faq/"
                      target="_blank"
                      style={{color: 'black'}}
                    >
                      https://www.google.com/analytics/tag-manager/faq/
                    </a>
                    {!isAppIimjobs && <br></br>}
                    {!isAppIimjobs && <br></br>}
                    Google+:{' '}
                    <a
                      href="https://www.google.com/policies/privacy/"
                      target="_blank"
                      style={{color: 'black'}}
                    >
                      https://www.google.com/policies/privacy/
                    </a>
                    {!isAppIimjobs && <br></br>}
                    {!isAppIimjobs && <br></br>}
                    Twitter:{' '}
                    <a
                      href="https://twitter.com/en/privacy"
                      target="_blank"
                      style={{color: 'black'}}
                    >
                      https://twitter.com/en/privacy
                    </a>
                    {!isAppIimjobs && <br></br>}
                    {!isAppIimjobs && <br></br>}
                    Google Double click:{' '}
                    <a
                      href="https://support.google.com/dfp_premium/answer/2839090?hl=en"
                      target="_blank"
                      style={{color: 'black'}}
                    >
                      https://support.google.com/dfp_premium/answer/2839090?hl=en
                    </a>
                  </>
                }
              />
              <Paragraph
                title="h. What are Web Beacons?"
                style={
                  !isAppIimjobs && {
                    fontSize: '16px',

                    lineHeight: '27px',
                    fontWeight: '400',
                  }
                }
                titleStyle={
                  !isAppIimjobs && {
                    fontSize: '16px',
                    fontWeight: 'fontWeightBold',
                  }
                }
                body={
                  <>
                    hirist.tech occasionally advertises on third party websites.
                    As part of our effort to track the success of our
                    advertising campaigns, we may at times use a visitor
                    identification technology such as &quot;web beacons,&quot;
                    or &quot;action tags,&quot; which count visitors who have
                    come to our site after being exposed to a hirist.tech banner
                    ad on a third-party site. Our partners may also use web
                    beacons to collect data in the aggregate as provided by your
                    browser while you are on our site or another site where
                    hirist.tech is a third party.
                    {!isAppIimjobs && <br></br>}
                    {!isAppIimjobs && <br></br>}
                    By navigating on our site, you agree that we can place
                    cookie and web beacons on your computer or device. If you
                    prefer not to receive web beacons, then you should stop
                    using our site, or consult your browsing settings.
                  </>
                }
              />
              <Paragraph
                title="i. How to control cookies?"
                style={
                  !isAppIimjobs && {
                    fontSize: '16px',

                    lineHeight: '27px',
                    fontWeight: '400',
                  }
                }
                titleStyle={
                  !isAppIimjobs && {
                    fontSize: '16px',
                    fontWeight: 'fontWeightBold',
                  }
                }
                body={
                  <>
                    Most browsers allow you to control cookies through their
                    settings preferences. However, if you choose to turn off
                    these cookies, you will still see advertising on the
                    internet but it may not be tailored to your interests. It
                    does not mean that you won&apos;t be served any
                    advertisements whilst you are online. Whilst we have
                    mentioned most of the third parties involved in using
                    targeting or advertising cookies in the preceding section,
                    the list is not exhaustive and is subject to change.
                    Therefore, even if you choose to turn off all the
                    third-party cookies listed in the section, you may still
                    receive some tailored advertisements and recommendations.
                    {!isAppIimjobs && <br></br>}
                    {!isAppIimjobs && <br></br>}
                    There are a number of ways you can manage what cookies are
                    set on your devices. Essential cookies, however, cannot be
                    disabled. If you do not allow certain cookies to be
                    installed, the website may not be accessible to you and/or
                    the performance, features, or services of the website may be
                    compromised.
                    {!isAppIimjobs && <br></br>}
                    {!isAppIimjobs && <br></br>}
                    You can also manage this type of cookie in the privacy
                    settings on the web browser you are using. Please note that
                    if you use your browser settings to block all cookies you
                    may not be able to access parts of our or other&apos;s
                    websites. Please see below for more information.
                    {!isAppIimjobs && <br></br>}
                    {!isAppIimjobs && <br></br>}
                    <b>
                      <i>Changing your Cookie Settings</i>:
                    </b>{' '}
                    The browser settings for changing your cookies settings are
                    usually found in the &apos;options&apos; or
                    &apos;preferences&apos; menu of your internet browser. In
                    order to understand these settings, the following links may
                    be helpful. Otherwise, you should use the &apos;Help&apos;
                    option in your internet browser for more details.
                    <Paragraph
                      title=""
                      style={{
                        ...(!isAppIimjobs && {
                          fontSize: '16px',

                          lineHeight: '27px',
                          fontWeight: '400',
                        }),
                      }}
                      body={
                        <>
                          <Box
                            component="ul"
                            sx={{
                              // listStyleType: 'lower-roman',
                              ...(!isAppIimjobs && {
                                li: {
                                  mt: 0,
                                  '::marker': {
                                    color: theme.palette.primary.main,
                                  },
                                },
                                pl: 4.5,
                              }),
                            }}
                          >
                            <li>
                              <a
                                href="https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies"
                                target="_blank"
                                style={{color: 'black'}}
                              >
                                Cookie settings in Internet Explorer{' '}
                                {!isAppIimjobs && <br />}
                                {!isAppIimjobs && <br />}
                              </a>
                            </li>
                            <li>
                              <a
                                href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences"
                                target="_blank"
                                style={{color: 'black'}}
                              >
                                Cookie settings in Firefox{' '}
                                {!isAppIimjobs && <br />}
                                {!isAppIimjobs && <br />}
                              </a>
                            </li>
                            <li>
                              <a
                                href="https://support.google.com/chrome/answer/95647"
                                target="_blank"
                                style={{color: 'black'}}
                              >
                                Cookie settings in Chrome
                                {!isAppIimjobs && <br />}
                                {!isAppIimjobs && <br />}
                              </a>
                            </li>
                            <li>
                              <a
                                href="https://support.apple.com/en-in/guide/safari/sfri11471/mac"
                                target="_blank"
                                style={{color: 'black'}}
                              >
                                Cookie settings in Safari
                                {!isAppIimjobs && <br />}
                                {!isAppIimjobs && <br />}
                              </a>
                            </li>
                          </Box>
                        </>
                      }
                    />
                  </>
                }
              />
              <Paragraph
                title=""
                style={
                  !isAppIimjobs && {
                    fontSize: '16px',

                    lineHeight: '27px',
                    fontWeight: '400',
                  }
                }
                titleStyle={
                  !isAppIimjobs && {
                    fontSize: '16px',
                    fontWeight: 'fontWeightBold',
                  }
                }
                body={
                  <>
                    <b>More information:</b> To find out more about cookies,
                    including how to see what cookies have been set and how to
                    manage and delete them, visit{' '}
                    <a
                      href="https://www.allaboutcookies.org/"
                      target="_blank"
                      style={{color: 'black'}}
                    >
                      www.allaboutcookies.org.
                    </a>{' '}
                    You can learn more about opting out of receiving
                    interest-based ads from other companies at{' '}
                    <a
                      href="https://optout.aboutads.info/"
                      target="_blank"
                      style={{color: 'black'}}
                    >
                      optout.aboutads.info
                    </a>{' '}
                    and{' '}
                    <a
                      href="https://www.networkadvertising.org/choices"
                      target="_blank"
                      style={{color: 'black'}}
                    >
                      www.networkadvertising.org/choices.
                    </a>{' '}
                    In addition, certain third-party advertising networks, like
                    Facebook (pixels) and Google, permit users to opt out of or
                    customize preferences associated with your internet
                    browsing. To learn more about this feature from Google,{' '}
                    <a href="" target="_blank" style={{color: 'black'}}>
                      click here
                    </a>
                    . For further information about the Facebook Pixel,{' '}
                    <a
                      href="https://www.facebook.com/business/help/651294705016616"
                      target="_blank"
                      style={{color: 'black'}}
                    >
                      click here.
                    </a>
                  </>
                }
              />
            </>
          ) : (
            <></>
          )}
        </Card>
      </Box>
      {!isAppIimjobs && (
        <Box
          sx={{
            marginBottom: '-64px',
          }}
        >
          <HomePageFooter isTransparent={true} />
        </Box>
      )}
    </Box>
  );
};

export default PrivacyPolicyPage;
